import * as Yup from 'yup';

export const categoryValidationSchema = Yup.object({
  name: Yup.string()
    .required('Category Name is required')
    .min(2, 'Category Name must be greater than 2 characters')
    .max(50, 'Category Name must be less than 50 characters'),
  categoryGroup: Yup.object({
    name: Yup.string(),
    id: Yup.number(),
  }).test(
    'categoryGroup',
    'Valid category group is required',
    (val) => val.id !== undefined && val.name !== undefined
  ),
  categorySubGroup: Yup.object({
    name: Yup.string(),
    id: Yup.number(),
  }),
  description: Yup.string().max(
    250,
    'Description cannot be greater than 250 characters.'
  ),
});
